import { CONTACT_US_API_BASE, CODE_PARAM, V2_CLIENT_CODE_KEY } from '../Constants/APIConstantsV2';

const postContactUs = (parameters) => {
    let url = new URL(`${CONTACT_US_API_BASE}`);
    //url.searchParams.append(CODE_PARAM, V2_CLIENT_CODE_KEY);

    return fetch(url, {
        
            method: "post",
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'x-functions-key': V2_CLIENT_CODE_KEY
            },
          
            //make sure to serialize your JSON body
            body: JSON.stringify({ ...parameters  })
         
    });
}

export default postContactUs;